/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Illegal_DecklistInputs */



/**
* | output |
* | --- |
* | "Illegal Decklist" |
*
* @param {Sanction_Sub_Illegal_DecklistInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_illegal_decklist = /** @type {((inputs?: Sanction_Sub_Illegal_DecklistInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Illegal_DecklistInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decklist Illégale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de Deck Ilegal")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Lista de Deck Ilegal")
	if (locale === "it") return /** @type {LocalizedString} */ ("Decklist Illegale")
	return /** @type {LocalizedString} */ ("Illegal Decklist")
});